import pushToDataLayer from "./pushToDataLayer";
import itemDataTemplate from "./itemDataTemplate";
import { CURRENCY_CODE } from "./constants";

const viewItemListEvent = savedItems => {
  const localCurrencyCode = savedItems[0]?.price.currency;

  pushToDataLayer({
    view_item_list: {
      item_list_name: "wishlist",
      ecommerce: {
        currency: CURRENCY_CODE,
        localCurrencyCode,
        items: savedItems.map((item, index) => itemDataTemplate(item, index))
      }
    }
  });
};

export default viewItemListEvent;
